export const validatePassword = (password: string): string | null => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const messages: string[] = [];
    if (password.length === 0) {
        return `Please enter a password`;
    }
    else {
        if (password.length < minLength) {
            messages.push(`${minLength} characters`);
        }
        if (!hasUpperCase) {
            messages.push("an uppercase letter");
        }
        if (!hasLowerCase) {
            messages.push("a lowercase letter");
        }
        if (!hasNumber) {
            messages.push("a number");
        }
        if (!hasSpecialChar) {
            messages.push("a special character");
        }
    }
    return messages.length > 0 ? `Password does not meet minimum requirements: At least ${messages.join(', ')}.` : null;
};
